import Parallax from "../../components/parallax/parallax";
import "./registry.scss";
import { useEffect, useState } from "react";
import LoadingOverlay from "../../components/loading/LoadingOverlay";

export default function Registry() {
  const [imagesLoaded, setImagesLoaded] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setImagesLoaded(true);
    }, 1500);
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <>
      <LoadingOverlay isLoading={!imagesLoaded} />
      <div
        className={`registry width-100 display-flex flex-column justify-center align-center text-center ${
          imagesLoaded ? "fade-in" : ""
        }`}
      >
        <div className="registry-banner">
          <div className="registry-banner-content display-flex flex-column justify-center align-center text-center">
            <h1 className="cormorant-light-400 letter-spacing-5 text-medium padding-top-22">
              REGISTRY
            </h1>
            <p className="padding-5">
              Your presence at our wedding and celebrating our special day with
              you is a gift in and of itself.
            </p>
            <p className="padding-left-5 padding-right-5 padding-bottom-25">
              Although we do not have a registry, should you wish to honour us
              with a gift, we would be grateful for a monetary contribution
              toward our future together.
            </p>
          </div>
        </div>
        <div className="registry-bg" />
      </div>
    </>
  );
}
